<template>
  <div id="app"><hr>
    <div class="container">
      <div class="row align-items-center">
        <div class="col">
          <div class="my-2" id="nav">
            <router-link to="/" class="btn"><!--<i class="fa fa-home"></i>-->
            <img src="../public/logo.png" alt="DOVA Logo" width=15 class="mb-1"> Dova</router-link>
            <router-link to="/about" class="btn"><i class="fa fa-info"></i> About</router-link>
            <router-link to="/poems" class="btn"><i class="fa fa-th-list"></i> Poems</router-link>
            <router-link to="/readers" class="btn"><i class="fa fa-address-card-o"></i> Readers</router-link>
          </div>
        </div>
        <div v-if="current_user.name" class="col-sm-3">
          <div>
            <router-link to="/readers" class="btn btn-sm border-da text-truncate m-1">{{current_user.name}}</router-link>
            <b class="btn btn-sm border-da my-1" @click="logout"><i class="fa fa-sign-out"></i></b>
          </div>
        </div>
      </div><!--End row-->
    </div><!--End 1st container--><hr>
    <router-view/>
  </div>
</template>

<script>
  import axios from 'axios';
  import './assets/css/main.css';

  export default{
    computed: {
      current_user() {
        return this.$store.getters.fetchUser;
      }
    },
    mounted() {
      this.$store.dispatch("fetchUser");
    },
    methods: {
      logout() {
        const token = window.localStorage.getItem('Bearer');
        if(token){
          window.localStorage.removeItem('Bearer');
          this.$store.commit('USER', false);
          this.$store.commit('USERS', false);
          if(this.$router.history.current.name!=='Readers'){
            this.$router.push({ name: 'Readers' });
          }
        }
      }
    }
  }
</script>
